export default __webpack_public_path__ + "images/O2.6fe2601.png";